// extracted by mini-css-extract-plugin
export var closeButton = "_67-0";